import { z } from "zod";

export const readingsDTOSchema = z.record(
  z.string(),
  z.tuple([
    // The initial offset. Due to how number arrays are encoded, separating
    // it out into its own field allows the other offsets to be stored as
    // single bytes in most cases, resulting in a much smaller payload
    z.number(),
    // Offsets
    z.array(z.number()),
    // Weights
    z.array(z.number().nullable()),
    // Board temperatures
    z.array(z.number()),
  ]),
);

export type ReadingsDTO = z.infer<typeof readingsDTOSchema>;
